let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lG26f")).then(() => parcelRequire('jKGXJ'));